import { Auth } from '@mdlinx/shared';
import { trackEvent, getLocationDetails } from 'lib/analytics';

export const postAuthIframeMessage = ({
  message,
  pathname,
  search,
}: {
  message: Auth.AbortResult;
  pathname: string;
  search: string;
}) => {
  if (message === Auth.abortLogin) {
    trackEvent(`auth_modal_closed`, { ...getLocationDetails(pathname, search) });
  }

  if (window.parent) {
    window.parent.postMessage(message, '*');
  }
};
